import { render, staticRenderFns } from "./VideoListComm.vue?vue&type=template&id=33bb8377&scoped=true&"
import script from "./VideoListComm.vue?vue&type=script&lang=js&"
export * from "./VideoListComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb8377",
  null
  
)

export default component.exports